module.exports = __webpack_public_path__ + "img/img_safety_banner.96f3a8ca.png";